
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { ServiceBase } from '../../../../shared/service-base/ServiceBase';


@Injectable()
export class OsService extends ServiceBase {
  private baseUrlService: string;

  url: string;

  public setUrl(numero: string) {
    this.url = `${this.baseUrlService}/os/${numero}`;
  }

  protected getURL(): string {
    return this.url;
  }

  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.baseUrlService = environment.URL_API
  }

}
